import React from 'react'

const SalesforceDeveloper = () => {
    return (
        <>
            <div className="container my-5">

                <h1 className='mb-5'><strong>Salesforce Developer</strong></h1>
                <p><strong>As more businesses rely on data and analytics for everything from sales and marketing to planning and customer management,&nbsp;Salesforce Developers are in high demand across nearly all industries&nbsp;and you can find a niche in anything from banking and software to healthcare and entertainment.</strong></p>
                {/* <p>
                    Here is the list of some of the popular companies which work for Salesforce technologies.

                </p>
                <ul className='unstyled-list'>
                    <li>Accenture</li>
                    <li>Capgemini</li>
                    <li>Tata Consultancy Services (TCS)</li>
                    <li>IBM</li>
                    <li>Deloitte</li>
                    <li>Cognizant</li>
                    <li>Wipro</li>
                    <li>Tech Mahindra</li>
                </ul> */}
                <h2 className="">Table of Content</h2>
                <ul>
                    <li>Program Overview</li>
                    <li>Salesforce Developer, Roles and Responsibilities</li>
                    <li>Program Features</li>
                    <li>Delivery Mode</li>
                    <li>Prerequisites</li>
                    <li>Target Audience</li>
                    <li>Key Learning Outcomes</li>
                    <li>Course Curriculum</li>
                </ul>
                <h2 className="">Program Overview</h2>
                <p>This Salesforce certification training course is designed to teach you how to master the concepts needed to become a Salesforce Platform Developer. You will learn how to design and code any functionality in  Salesforce to collect, analyze, and retrieve vital customer information and to create applications using Salesforce Lightning.</p>
                <h2 className="">Salesforce Developer, Role and Responsibilities</h2>
                <ul>
                    <li>Customization and Configuration</li>
                    <li>Apex Development</li>
                    <li>Integration</li>
                    <li>Data Management</li>
                    <li>Governance and Best Practices</li>
                    <li>Testing</li>
                    <li>Security</li>
                    <li>Documentation</li>
                    <li>Continuous Learning</li>
                    <li>Collaboration</li>
                </ul>
                <h2 className="">Program Features</h2>
                <ul>
                    <li>110 hours of total duration of learning</li>
                    <li>50 hours of instructor-led live training</li>
                    <li>30 hours of hands-on practice with Salesforce Lightning</li>
                    <li>30 hours of Online self-paced learning</li>
                    <li>5 industry projects with 30 case studies</li>
                </ul>
                <h2 className="">Delivery Mode</h2>
                <p>Instructor led Live online training</p>
                <h2 className=""><strong>Prerequisites</strong></h2>
                <p>There are no prerequisites for this training course, but it’s good to have experience of working as an administrator or developer.</p>
                <h2 className="">Target Audience</h2>
                <ul>
                    <li>App builders</li>
                    <li>Developers</li>
                    <li>System administrators</li>
                    <li>Sales representatives</li>
                    <li>IT managers</li>
                    <li>Product managers</li>
                </ul>
                <h2 className="">Key Learning Outcomes</h2>
                <p>After completing this course you will be able to:</p>
                <ul>
                    <li>Proficient to work with objects</li>
                    <li>Good understanding of Salesforce</li>
                    <li>Ability to write efficient apex code</li>
                    <li>Ability to implement process automations in Salesforce</li>
                    <li>Working with Customizations</li>
                    <li>Master in salesforce technical</li>
                    <li>Design and develop new application in Salesforce</li>
                </ul>
                <p></p>
                <h2 className="">Course Curriculum</h2>
                <p></p>
                <ol>
                    <li><strong>Salesforce and Apex Fundamentals</strong>
                        <ol>
                            <li>Salesforce Lightning Platform basics and features</li>
                            <li>Apex Programming language and features</li>
                            <li>Constants, variables and datatype</li>
                            <li>Primitive and non primitive data type</li>
                            <li>Collections(List, set and map)</li>
                            <li>Expressions and Operators</li>
                        </ol>
                    </li>
                    <li><strong>Control Flow</strong>
                        <ol>
                            <li>If-Else Statement</li>
                            <li>Switch-When Statement</li>
                            <li>Conditional Statement</li>
                            <li>Loops</li>
                            <li>Break and Continue Statement</li>
                        </ol>
                    </li>
                    <li><strong>Apex Class and Method</strong>
                        <ol>
                            <li>Access Modifier</li>
                            <li>Apex Methods</li>
                            <li>Parameterized methods</li>
                            <li>Polymorphic methods</li>
                            <li>Apex Class Lifecycle</li>
                            <li>Inner Class or Wrapper class</li>
                        </ol>
                    </li>
                    <li><strong>Salesforce Object Query Language(SOQL)</strong>
                        <ol>
                            <li>SOQL Basics</li>
                            <li>SOQL in Apex</li>
                            <li>SOQL Variable Binding</li>
                            <li>SOQL Return Type</li>
                            <li>SOQL Functions</li>
                            <li>SOQL Keywords</li>
                            <li>Date Literals</li>
                            <li>Child to Parent Relationship</li>
                            <li>Parent to Child Relationship</li>
                            <li>Multi-Level Relationship</li>
                            <li>Dynamic SOQL</li>
                            <li>SOSL</li>
                        </ol>
                    </li>
                    <li><strong>Apex DML Statements and Database Method</strong>
                        <ol>
                            <li>Apex DML basics</li>
                            <li>DML SOQL Best practices</li>
                            <li>Database Class</li>
                            <li>Database Methods vs DML Statement</li>
                            <li>Insert and update operations</li>
                            <li>Delete and Undelete Operation</li>
                            <li>Delete and Undelete Operations</li>
                            <li>sObject Overview</li>
                        </ol>
                    </li>
                    <li><strong>Exception Handling</strong>
                        <ol>
                            <li>Basics of Exception</li>
                            <li>custom or user defined exception</li>
                            <li>System Exception</li>
                            <li>try, catch and finally</li>
                            <li>exception method and throw</li>
                        </ol>
                    </li>
                    <li><strong>Governor limits and Code Bulkification</strong>
                        <ol>
                            <li>Transaction</li>
                            <li>Bulkification</li>
                            <li>CPU Timeout exception</li>
                            <li>Limits Class</li>
                            <li>Heap Size Limit</li>
                        </ol>
                    </li>
                    <li><strong>Apex Triggers</strong>
                        <ol>
                            <li>Trigger Basics</li>
                            <li>Type of Triggers</li>
                            <li>Trigger Context Variables</li>
                            <li>Order of Execution</li>
                            <li>Trigger best practices</li>
                            <li>Trigger exceptions and validations</li>
                        </ol>
                    </li>
                    <li><strong>Async Apex</strong>
                        <ol>
                            <li>Async Apex Overview</li>
                            <li>Future Methods</li>
                            <li>Batch Apex</li>
                            <li>Queueable Apex</li>
                            <li>Scheduled Apex</li>
                        </ol>
                    </li>
                    <li><strong>Visualforce</strong>
                        <ol>
                            <li>Visualforce Basics</li>
                            <li>Standard controller</li>
                            <li>View Page</li>
                            <li>Edit Page</li>
                            <li>Custom Controller</li>
                            <li>Order of Execution</li>
                        </ol>
                    </li>
                    <li><strong>Integrations</strong>
                        <ol>
                            <li>Web Services</li>
                            <li>Apex callout
                                <ul></ul>
                            </li>
                        </ol>
                    </li>
                    <li><strong>Apex Testing</strong>
                        <ol>
                            <li>Introduction of Apex Testing</li>
                            <li>Assert Statement</li>
                            <li>Apex test Data</li>
                            <li>Test Setup, Start Test and Stop test</li>
                            <li>Bulk Test</li>
                        </ol>
                    </li>
                    <li><strong>Security</strong>
                        <ol>
                            <li>Introduction of Salesforce Security Model</li>
                            <li>Custom Code Security</li>
                        </ol>
                    </li>
                    <li><strong>Introduction of Lightning Web Components(LWC)</strong>
                        <ol>
                            <li>LWC Basics</li>
                            <li>Development Tools</li>
                            <li>Lightning web Components vs Web Components</li>
                            <li>Lightning Data Services and Wire Method</li>
                        </ol>
                    </li>
                </ol>
                <p></p>
                <p></p>
            </div>
        </>
    )
}

export default SalesforceDeveloper